import React from 'react';
import { Toggle } from '@chargify/custom-ui-components';

import { renderPrice } from './renderPrice';
import { Allocation, SerializedComponent } from '../../../machines';
import { ComponentPreview } from '../types';

export const createOnOffRow = (
  component: SerializedComponent,
  onUpdateAllocation: (allocation: Allocation) => void,
  locale: string
): ComponentPreview => ({
  name: component.name,
  description: component.description,
  memo: component.memo,
  renderPrice: () => renderPrice(component.price, locale),
  renderControl: () => (
    <Toggle
      isDisabled={!component.updatesAllowed}
      variant="reversed"
      isOn={!!component.allocatedQuantity}
      onChange={(value) =>
        onUpdateAllocation({
          id: component.id,
          quantity: value ? 1 : 0,
          memo: component.memo,
        })
      }
    />
  ),
  disableMemo: !component.updatesAllowed,
  ...(component.updatesAllowed && {
    onMemoChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      onUpdateAllocation({
        id: component.id,
        quantity: component.allocatedQuantity ? 1 : 0,
        memo: e?.target?.value || '',
      }),
  }),
});
